<h2 mat-dialog-title>JSON Gym details</h2>
<mat-dialog-content>
  <mat-form-field class="json-field">
    <mat-label>JSON</mat-label>
    <textarea
      #payload
      matInput
      readonly="readonly"
      cdkTextareaAutosize
      [cdkAutosizeMinRows]="10"
      [cdkAutosizeMaxRows]="20"
      class="json-area"
      >{{ gymDetails | json }}</textarea
    >
  </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions align="center">
  <button mat-raised-button [cdkCopyToClipboard]="payload.value">
    <mat-icon> content_copy </mat-icon>
    Copy to clipboard
  </button>
  <button mat-raised-button (click)="downloadFile()">
    <mat-icon> file_download </mat-icon>
    Download
  </button>
  <button mat-raised-button (click)="closeDialog()" color="primary">
    Close
  </button>
</mat-dialog-actions>
